module.exports = __webpack_public_path__ + "static/img/dict_desk_1.e139d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dict_desk_1.png
// module id = QFBP
// module chunks = 1